import { useNavigate } from "react-router-dom";

import config from '../../config';
import homecook_logo from "../../assets/img/homecook_logo.png";
import { ReactComponent as HomeIcon } from '../../icons/HomeIcon.svg';
import { ReactComponent as FoodEntrepreneurIcon } from '../../icons/FoodEntrepreneur.svg';
import { ReactComponent as ResourceProvidersIcon } from '../../icons/KitchenOperator.svg';
import { ReactComponent as FaqQuestionIcon } from '../../icons/FaqQuestionIcon.svg';
import { ReactComponent as ResourcePantryIcon } from '../../icons/ResourcePantryIcon.svg';
import { ReactComponent as PawditProductIcon } from '../../icons/AIIcon.svg';
import { ReactComponent as ComplianceProductIcon } from '../../icons/documentationIcon.svg';
import { ReactComponent as InstagramIcon } from '../../icons/InstagramIcon.svg';
import { ReactComponent as PartnerDashboardIcon } from '../../icons/KitchenOperatorDark.svg';

var webUrl = config?.webUrl
var partnerDashboardUrl = config?.partnerDashboardUrl;
const Footer = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate("/");
  }

  const goToFoodEntrepreneurs = () => {
    navigate("/food-entrepreneurs");
  }

  const goToResourceProviders = () => {
    navigate("/resource-providers");
  }

  const goToFaqPage = () => {
    navigate("/faq-page");
  }

  const openInNewTab = (url: string) => {
    window.open(url, "_blank");
  };

  const goToInstagram = () => {
    openInNewTab("https://www.instagram.com/homecook.app/");
  }

  return (
    <footer className="px-[120px] text-text-1000">
      <div className="bg-primaryDark-0 rounded-t-[24px] p-[100px] max-w-[1550px] mx-auto">
        <div className="grid grid-cols-4">
          {/* First Column */}
          <div>
            {/* Homecook Logo */}
            <div className="flex items-center gap-[8px]">
              <img src={homecook_logo} alt="Homecook Logo" className="w-[32px] h-[32px]" />
              <h4 className="text-[24px] font-semibold text-text-1000 font-raleway">HomeCook App</h4>
            </div>

            <p className="text-text-1000 text-[16px] font-open-sans mt-[8px]">© 2026 HomeCook LLC</p>
          </div>

          {/* Second Column */}
          <div>
            <h5 className="font-raleway text-[20px] text-text-1000 font-semibold">Navigation</h5>

            {/* Links */}
            <div className="mt-[24px]">
              {/* Home Link */}
              <div onClick={goToHome} className="flex items-center gap-[8px] mb-[24px] cursor-pointer hover:scale-95 transition-all">
                <HomeIcon className="w-[24px] h-[24px]" />
                <p className="font-raleway text-[16px]">Home</p>
              </div>

              {/* Food Entrepreneurs Link */}
              <div onClick={goToFoodEntrepreneurs} className="flex items-center gap-[8px] mb-[24px] cursor-pointer hover:scale-95 transition-all">
                <FoodEntrepreneurIcon className="w-[24px] h-[24px]" />
                <p className="font-raleway text-[16px]">Food Entrepreneurs</p>
              </div>

              {/* Resource Providers Link */}
              <div onClick={goToResourceProviders} className="flex items-center gap-[8px] mb-[24px] cursor-pointer hover:scale-95 transition-all">
                <ResourceProvidersIcon className="w-[24px] h-[24px]" />
                <p className="font-raleway text-[16px]">Resource Providers</p>
              </div>

              {/* FAQ Link */}
              <div onClick={goToFaqPage} className="flex items-center gap-[8px] cursor-pointer hover:scale-95 transition-all">
                <FaqQuestionIcon className="w-[24px] h-[24px]" />
                <p className="font-raleway text-[16px]">FAQs</p>
              </div>
            </div>
          </div>

          {/* Third Column */}
          <div>
            <h5 className="font-raleway text-[20px] text-text-1000 font-semibold">Products</h5>

            {/* Links */}
            <div className="mt-[24px] space-y-[24px]">
              <a
                href={webUrl}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-[8px] hover:scale-95 transition-all font-raleway text-[16px]"
              >
                <ResourcePantryIcon className="w-[24px] h-[24px]" aria-hidden />
                Resource Pantry
              </a>
              <a
                href={partnerDashboardUrl}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-[8px] hover:scale-95 transition-all font-raleway text-[16px]"
              >
                <PartnerDashboardIcon className="w-[24px] h-[24px]" aria-hidden />
                Partner Dashboard
              </a>
              <a
                href={"/compliance"}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-[8px] hover:scale-95 transition-all font-raleway text-[16px]"
              >
                <ComplianceProductIcon className="w-[24px] h-[24px]" aria-hidden />
                Compliance Readiness Tool
              </a>
              {/* <div onClick={() => navigate("/compliance")} className="flex items-center gap-[8px] cursor-pointer hover:scale-95 transition-all font-raleway text-[16px]">
                <ComplianceProductIcon className="w-[24px] h-[24px]" aria-hidden />
                Compliance Readiness Tool
              </div> */}
               <a
                href={"/pawdit"}
                target="_blank"
                rel="noreferrer"
                className="flex items-center gap-[8px] hover:scale-95 transition-all font-raleway text-[16px]"
              >
                <PawditProductIcon className="w-[24px] h-[24px]" aria-hidden />
                Pawdit
              </a>
              {/* <div onClick={() => navigate("/pawdit")} className="flex items-center gap-[8px] cursor-pointer hover:scale-95 transition-all font-raleway text-[16px]">
                <PawditProductIcon className="w-[24px] h-[24px]" aria-hidden />
                Pawdit
              </div> */}
            </div>
          </div>

          {/* Fourth Column */}
          <div>
            <h5 className="font-raleway text-[20px] text-text-1000 font-semibold">Socials</h5>

            {/* Links */}
            <div onClick={goToInstagram} className="flex items-center gap-[8px] mt-[24px] cursor-pointer hover:scale-95 transition-all">
              <InstagramIcon className="w-[24px] h-[24px]" />
              <p className="flex items-center gap-[8px] hover:scale-95 transition-all font-raleway text-[16px]">Instagram</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
